<template>
    <div id="datos">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :xs="24" :sm="24" :md="22">
                <el-row :gutter="20">

                    <el-col :span="24">
                        <v-alert v-if="validar" type="warning" color="orange" style="margin-bottom:30px" :value="true">
                            <strong>Validar Datos.</strong><br>Por favor, complete sus Datos Profesionales.
                        </v-alert>
                    </el-col>

                    <el-col :xs="24" :sm="12">

                        <!-- Datos Personales -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Datos Personales</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <strong>DNI/CUIL: </strong>
                                    <span v-if="datospersonales.pre_cuil">{{ datospersonales.pre_cuil }} - </span>
                                    {{ datospersonales.DNI }}
                                    <span v-if="datospersonales.pos_cuil"> - {{ datospersonales.pos_cuil }}</span><br>
                                <strong>Apellido/s: </strong> {{ datospersonales.Apellido }} <br>
                                <strong>Nombre/s: </strong> {{ datospersonales.Nombre }} <br>
                                <strong>Fecha de Nacimiento: </strong> {{ datospersonales.Nacimiento }} <br>
                                <strong>Sexo: </strong> {{ datospersonales.Sexo | SexoPipe }} <br>
                                <strong>Localidad: </strong> {{ datospersonales.Localidad }} <br>
                                <strong>Título Profesional: </strong> {{ datospersonales.Titulo_profesional }} <br>
                            </div>
                            <hr>
                            <router-link :to="'editar/personales'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Datos de Contacto -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Datos de Contacto</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <strong>Mail: </strong> {{ datoscontacto.Mail }} <br>
                                <strong>Teléfono: </strong> {{ datoscontacto.Telefono }} <br>
                                <strong>Teléfono Celular: </strong> {{ datoscontacto.Celular }} <br>
                            </div>
                            <hr>
                            <router-link :to="'editar/personales'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Foto de Perfil -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Foto de Perfil</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px" v-if="foto">
                                <img :src="foto" style="width:100%"/>
                            </div>
                            <hr>
                            <router-link :to="'editar/foto'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- DNI Digital -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>DNI Digital</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px" align="center">
                                <a :href="dnidigital" class="el-button el-button--success" target="_blank" v-if="dnidigital!=''">Descargar</a>
                            </div>
                            <hr>
                            <router-link :to="'editar/dni'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Título Habilitante -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Título Habilitante</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px" v-if="titulo">
                                <center>
                                    <a 
                                        href=""
                                        class="el-button el-button--success" 
                                        @click.prevent="downloadItem()"
                                    >
                                        Descargar
                                    </a>
                                </center>
                            </div>
                            <hr>
                            <router-link :to="'editar/titulo'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                    </el-col>
                    <el-col :xs="24" :sm="12">

                        <!-- Cargos -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Cargos</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <span v-for="(item, index) in cargos" :key="index">{{ item }}<br></span>
                            </div>
                            <hr>
                            <router-link :to="'editar/cargos'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Niveles -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Niveles</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <span v-for="(item, index) in niveles" :key="index">{{ item }}<br></span>
                            </div>
                            <hr>
                            <router-link :to="'editar/niveles'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Modalidades -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Modalidades</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <span v-for="(item, index) in modalidades" :key="index">{{ item }}<br></span>
                            </div>
                            <hr>
                            <router-link :to="'editar/modalidades'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Areas -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Areas</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <span v-for="(item, index) in areas" :key="index">{{ item }}<br></span>
                            </div>
                            <hr>
                            <router-link :to="'editar/areas'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Establecimientos Declarados -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Establecimientos Declarados</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <span v-for="(item, index) in establecimientos" :key="index">{{ item }}<br></span>
                            </div>
                            <hr>
                            <router-link :to="'editar/establecimientos'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                        <!-- Circuitos -->
                        <div class="cuerpo">
                            <div align="center">
                                <strong>Circuitos</strong>
                            </div>
                            <hr>
                            <div style="padding:0px 20px 0px 20px">
                                <span v-for="(item, index) in circuitos" :key="index">Circuito {{ item }}<br></span>
                            </div>
                            <hr>
                            <router-link :to="'editar/circuitos'" class="el-col el-col-24 el-button el-button--primary">Modificar</router-link>
                            <br>
                        </div>

                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios from 'axios';

    export default
    {   filters:
        {   SexoPipe: function(value)
            {   if(value=='F')  return 'Femenino';
                else            return 'Masculino';
            }
        },
        data()
        {   return {
                datospersonales:    [],
                datoscontacto:      [],
                areas:              [],
                asignaturas:        [],
                cargos:             [],
                circuitos:          [],
                establecimientos:   [],
                modalidades:        [],
                niveles:            [],
                foto:               '',
                dnidigital:         '',
                titulo:             '',
                validar:            false,
            }
        },



/*agregar esto para que funione local https://cors-anywhere.herokuapp.com/*/
         methods: {
            downloadItem () 
            {   axios.get('https://docentes.educaciondigitaltuc.gob.ar/' + this.titulo, { responseType: 'blob' })
                    .then(response => {
                        const blob      = new Blob([response.data], { type: 'application/pdf' });
                        const link      = document.createElement('a');
                        link.href       = URL.createObjectURL(blob);
                        link.download   = 'Titulo Habilitante';
                        link.click();
                        URL.revokeObjectURL(link.href);
                    }).catch(console.error)
            },
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc.php', params, {headers: headers})
                    .then(response => {
                        const datos             = response.data
                        this.datospersonales    = datos['personales'];
                        this.datoscontacto      = datos['contacto'];
                        this.foto               = datos['foto'];
                        this.dnidigital         = datos['dni'];
                        this.titulo             = datos['titulo'];
                        this.areas              = datos['areas'];
                        this.cargos             = datos['cargos'];
                        this.circuitos          = datos['circuitos'];
                        this.modalidades        = datos['modalidades'];
                        this.niveles            = datos['niveles'];
                        this.establecimientos   = datos['establecimientos'];
                        if(datos['validar'])    this.validar = true;
                    })
                    .catch(e => {})
            }
        }
    }
</script>
